import { render, staticRenderFns } from "./EditAndShare.vue?vue&type=template&id=4a6cec89&scoped=true"
import script from "./EditAndShare.vue?vue&type=script&lang=js"
export * from "./EditAndShare.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditAndShare.vue?vue&type=style&index=1&id=4a6cec89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cec89",
  null
  
)

export default component.exports